import { render, staticRenderFns } from "./EditarGeneral.vue?vue&type=template&id=7cfeccf5&"
import script from "./EditarGeneral.vue?vue&type=script&lang=ts&"
export * from "./EditarGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports